export const isElem = (elem) => typeof elem === "object" && elem?.tagName